import store from "@/store";

const notification = {
    namespaced:true,
    store,
    state(){
        return {
            snackbar: {
                active: false,
                type:"",
                content:""
            }
        }
    },
    mutations:{
        snackbar(state,payload){
            state.snackbar.active = true
            state.snackbar.type = payload.type
            state.snackbar.content = payload.content
        }
    },
    actions:{
       snackbar(context,payload){
        return context.commit('snackbar',payload.data)
       }
    },
    getters:{
        snackbar(state){
            return state.snackbar
        }
    }

} 

export default notification